import permissions from "@/helpers/Permissions.js";

export const AdminMenuMixin = {
  data: () => ({
    user: null,
    menu: Array,
  }),

  methods: {
    buildMenu(user) {
      this.menu = [];
      if (user) {
        this.user = user;
        this.addHomeMenu();
        this.addSearchMenu();
        this.addReportMenu();
        this.addAdminMenu();
        this.addGenerateTokenMenu();
        this.addUpdatesMenu();
        this.addHelpMenu();
      }
      return this.menu;
    },
    addSearchMenu() {
      if (this.hasSearchFunctionality()) {
        const searchMenuItens = [];
        this.addAirlineFlightsMenu(searchMenuItens);
        this.addCrewMenu(searchMenuItens);
        const item = {
          icon: "mdi-account-search",
          "icon-alt": "mdi-account-search-outline",
          text: this.$t("search"),
          model: false,
          children: searchMenuItens,
        };
        this.menu.push(item);
      }
    },
    hasSearchFunctionality() {
      return (
        this.user.groups.includes(permissions.AIRLINE_FLIGHT_LIST) ||
        this.user.groups.includes(permissions.SEARCH_PASSENGERS) ||
        this.user.groups.includes(permissions.SEARCH_CREW)
      );
    },
    addAirlineFlightsMenu(searchMenuItens) {
      if (this.user.groups.includes(permissions.AIRLINE_FLIGHT_LIST)) {
        const item = {
          icon: "mdi-airplane",
          "icon-alt": "mdi-airplane",
          text: this.$t("airlineFlight"),
          link: "airline-flights",
          hint: this.$t("airlineFlightsHint"),
        };
        searchMenuItens.push(item);
      }
    },
    addCrewMenu(searchMenuItens) {
      if (this.user.groups.includes(permissions.SEARCH_CREW)) {
        const item = {
          icon: "mdi-account-tie-hat",
          text: this.$t("crew"),
          link: "crews",
        };
        searchMenuItens.push(item);
      }
    },
    addAdminMenu() {
      if (this.hasAdminFunctionality()) {
        const adminMenuItens = [];
        this.addListRoleMenu(adminMenuItens);
        this.addListUserMenu(adminMenuItens);
        // this.addImportUserMenu(adminMenuItens); temporariamente desativado
        this.addListOrganizationsMenu(adminMenuItens);
        this.addListAirportsMenu(adminMenuItens);
        this.addListApiAuditMenu(adminMenuItens);
        this.addListOrganizationAirportMenu(adminMenuItens);
        this.addListCountryMenu(adminMenuItens);
        this.addListAirlinesMenu(adminMenuItens);
        this.addCustomerMenu(adminMenuItens);
        const item = {
          icon: "mdi-cog",
          "icon-alt": "mdi-cog",
          text: this.$t("administration"),
          model: false,
          children: adminMenuItens,
        };
        this.menu.push(item);
      }
    },
    hasAdminFunctionality() {
      return (
        this.user.groups.includes(permissions.ROLE_MANAGE) ||
        this.user.groups.includes(permissions.USER_MANAGE) ||
        this.user.groups.includes(permissions.API_AUDIT_SEARCH) ||
        this.user.groups.includes(permissions.INTEGRATOR_MANAGE) ||
        this.user.groups.includes(permissions.ORGANIZATION_MANAGE) ||
        this.user.groups.includes(permissions.AIRPORT_MANAGE) ||
        this.user.groups.includes(permissions.USER_AIRPORT) ||
        this.user.groups.includes(permissions.ORGANIZATION_AIRPORT) ||
        this.user.groups.includes(permissions.COUNTRY_MANAGE) ||
        this.user.groups.includes(permissions.AIRLINE_MANAGE)
      );
    },
    addListRoleMenu(adminMenuItens) {
      if (this.user.groups.includes(permissions.ROLE_MANAGE)) {
        const item = {
          icon: "mdi-menu",
          text: this.$t("role"),
          link: "list-role",
          hint: this.$t("roleHint"),
        };
        adminMenuItens.push(item);
      }
    },
    addListUserMenu(adminMenuItens) {
      if (this.user.groups.includes(permissions.USER_MANAGE)) {
        const item = {
          icon: "mdi-account-details-outline",
          text: this.$t("user"),
          link: "list-user",
          hint: this.$t("userHint"),
        };
        adminMenuItens.push(item);
      }
    },
    // addImportUserMenu(adminMenuItens) {
    //   if (this.user.groups.includes(permissions.USER_MANAGE)) {
    //     const item = {
    //       icon: "mdi-account-details-outline",
    //       text: this.$t("importUser"),
    //       link: "import-user",
    //       hint: this.$t("userHint"),
    //     };
    //     adminMenuItens.push(item);
    //   }
    // },
    addListOrganizationsMenu(adminMenuItens) {
      if (this.user.groups.includes(permissions.ORGANIZATION_MANAGE)) {
        const item = {
          icon: "mdi-domain",
          text: this.$t("organizations"),
          link: "list-organization",
          hint: this.$t("organizationsHint"),
        };
        adminMenuItens.push(item);
      }
    },
    addListAirportsMenu(adminMenuItens) {
      if (this.user.groups.includes(permissions.AIRPORT_MANAGE)) {
        const item = {
          icon: "mdi-airport",
          text: this.$t("airports"),
          link: "list-airport",
          hint: this.$t("airportsHint"),
        };
        adminMenuItens.push(item);
      }
    },
    addListApiAuditMenu(adminMenuItens) {
      if (this.user.groups.includes(permissions.API_AUDIT_SEARCH)) {
        const item = {
          icon: "mdi-database-search",
          text: this.$t("apiAudit"),
          link: "list-api-audit",
          hint: this.$t("apiAuditHint"),
        };
        adminMenuItens.push(item);
      }
    },
    addListOrganizationAirportMenu(adminMenuItens) {
      if (this.user.groups.includes(permissions.ORGANIZATION_AIRPORT)) {
        const item = {
          icon: "mdi-airport",
          text: this.$t("organization_airport"),
          link: "list-organization-airport",
          hint: this.$t("organization_airportHint"),
        };
        adminMenuItens.push(item);
      }
    },
    addListCountryMenu(adminMenuItens) {
      if (this.user.groups.includes(permissions.COUNTRY_MANAGE)) {
        const item = {
          icon: "mdi-earth",
          text: this.$t("countries"),
          link: "list-country",
          hint: this.$t("countryHint"),
        };
        adminMenuItens.push(item);
      }
    },
    addListAirlinesMenu(adminMenuItens) {
      if (this.user.groups.includes(permissions.AIRLINE_MANAGE)) {
        const item = {
          icon: "mdi-shield-airplane",
          text: this.$t("airlines"),
          link: "list-airline",
          hint: this.$t("airlinesHint"),
        };
        adminMenuItens.push(item);
      }
    },
    addGenerateTokenMenu() {
      if (this.user.groups.includes(permissions.INTEGRATOR)) {
        const item = {
          icon: "mdi-shield-key",
          text: this.$t("generateToken"),
          link: "generate-token",
          hint: this.$t("generateTokenHint"),
        };
        this.menu.push(item);
      }
    },
    addIndicatorsReportMenu(reportMenuItens) {
      if (this.user.groups.includes(permissions.INDICATORS_REPORT)) {
        const item = {
          icon: "mdi-chart-bar",
          text: this.$t("indicatorsReport"),
          link: "indicators-report",
        };
        reportMenuItens.push(item);
      }
      if (this.user.groups.includes(permissions.INDICATORS_EMBARQUESEGURO_REPORT)) {
        const item = {
          icon: "mdi-chart-bar",
          text: this.$t("indicatorsEmbarqueReport"),
          link: "indicators-embarque-report",
        };
        reportMenuItens.push(item);
      }
    },
    addGraphicIndicatorsApiReportMenu(reportMenuItens) {
      if (
        this.user.groups.includes(permissions.GRAPHIC_INDICATORS_API_REPORT)
      ) {
        const item = {
          icon: "mdi-chart-bar",
          text: this.$t("graphicIndicatorsApiReport"),
          link: "graphic-indicators-api-report",
        };
        reportMenuItens.push(item);
      }
    },
    addGraphicIndicatorsReportMenu(reportMenuItens) {
      if (this.user.groups.includes(permissions.GRAPHIC_INDICATORS_REPORT)) {
        const item = {
          icon: "mdi-chart-bar",
          text: this.$t("graphicIndicatorsEmbarqueReport"),
          link: "graphic-indicators-embarque-report",
        };
        reportMenuItens.push(item);
      }
    },
    addApiRequestReportMenu(reportMenuItens) {
      if (this.user.groups.includes(permissions.API_REQUEST_REPORT)) {
        const item = {
          icon: "mdi-database-search",
          text: this.$t("apiRequestReport"),
          link: "api-request-report",
        };
        reportMenuItens.push(item);
      }
    },
    hasReportFunctionality() {
      return (
        this.user.groups.includes(permissions.INDICATORS_REPORT) ||
        this.user.groups.includes(permissions.INDICATORS_EMBARQUESEGURO_REPORT) ||
        this.user.groups.includes(permissions.GRAPHIC_INDICATORS_REPORT) ||
        this.user.groups.includes(permissions.GRAPHIC_INDICATORS_API_REPORT) ||
        this.user.groups.includes(permissions.API_REQUEST_REPORT)
      );
    },
    addReportMenu() {
      if (this.hasReportFunctionality()) {
        const reportMenuItens = [];
        this.addIndicatorsReportMenu(reportMenuItens);
        this.addGraphicIndicatorsReportMenu(reportMenuItens);
        this.addGraphicIndicatorsApiReportMenu(reportMenuItens);
        this.addApiRequestReportMenu(reportMenuItens);
        const item = {
          icon: "mdi-file-document-multiple",
          "icon-alt": "mdi-file-document-multiple-outline",
          text: this.$t("reports"),
          model: false,
          children: reportMenuItens,
        };
        this.menu.push(item);
      }
    },
    addCustomerMenu(adminMenuItens) {
      if (this.user.groups.includes(permissions.BILLING_MANAGE)) {
        const item = {
          icon: "mdi-cash-multiple",
          text: this.$t("billing"),
          link: "list-billing",
          hint: this.$t("billingHint"),
        };
        adminMenuItens.push(item);
      }
    },
    addUpdatesMenu() {
      if (
        this.user.groups.includes(permissions.UPDATES_READ) ||
        this.user.groups.includes(permissions.UPDATES_EDIT)
      ) {
        let query;
        if (this.user.groups.includes(permissions.UPDATES_EDIT)) {
          query = { enableEdit: "true" };
        }
        const item = {
          icon: "mdi-bullhorn",
          "icon-alt": "mdi-bullhorn-outline",
          text: this.$t("updates"),
          link: "list-updates",
          hint: this.$t("updatesHint"),
          query: query,
        };
        this.menu.push(item);
      }
    },
    addHelpMenu() {
      if (
        this.user.groups.includes(permissions.HELP_READ) ||
        this.user.groups.includes(permissions.HELP_EDIT)
      ) {
        let query;
        if (this.user.groups.includes(permissions.HELP_EDIT)) {
          query = { enableEdit: "true" };
        }
        const item = {
          icon: "mdi-help-circle",
          text: this.$t("help"),
          link: "list-help",
          hint: this.$t("helpHint"),
          query: query,
        };
        this.menu.push(item);
      }
    },
    addHomeMenu() {
      const item = {
        icon: "mdi-home",
        text: this.$t("home"),
        link: "home",
      };
      this.menu.push(item);
    },
  },
};
